import "./CaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import CaseStudiesIntroduction from "./sections/CaseStudiesIntroduction";
import ProjectGallery from "./sections/ProjectGallery";
import ExploreMoreCTA from "./sections/ExploreMoreCTA";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesPage() {
  return <div>
      <Header />
      <CaseStudiesIntroduction />
      <ProjectGallery />
      <ExploreMoreCTA />
      <Footer />
    </div>;
}